'use client';

import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';

import { filterNullable } from '@flipster/contentful-graphql/client';

import { Missions as SharedMissions } from '../shared/missions';
import { MissionGroup, MissionsDataSource, MissionsDataSourceContext } from '../shared/missions/state';
import { rollAndMoveMissionsBunja } from './state';

export const rollAndMoveMissionsDataSourceBunja = bunja(() => {
  const { missionsAtom, missionsLayout, eventId } = bunja.use(rollAndMoveMissionsBunja);

  if (!eventId || !missionsLayout) {
    return { dataSource: null };
  }

  const groups: MissionGroup[] = filterNullable(missionsLayout).map((item) => ({
    id: item.sys.id,
    title: item.title,
    icon: item.icon,
    tasks: filterNullable(item.tasksCollection?.items).map((task) => ({
      id: task.id,
      title: task.title,
      description: task.description,
      badge: task.badge,
      button: task.button as { text: string; web: string; app?: string } | null,
    })),
  }));

  const dataSource: MissionsDataSource = {
    slug: eventId,
    eventLocation: 'roll-and-move',
    groups,
    missionsAtom,
    showUpdatedTime: false,
  };

  return { dataSource };
});

export const Missions = () => {
  const { dataSource } = useBunja(rollAndMoveMissionsDataSourceBunja);

  if (!dataSource) return null;

  return (
    <MissionsDataSourceContext.Provider value={dataSource}>
      <SharedMissions />
    </MissionsDataSourceContext.Provider>
  );
};
